const locations = ["Sanok", "Brzozów", "Lesko", "Ustrzyki Dolne", "Dynów", "Bieszczady", "Podkarpacie"];

export default function LocalAreaSection() {
  return (
    <section className="w-full bg-white py-16 md:py-24">
      <div className="mx-auto max-w-[1440px] px-4 md:px-8 lg:px-16 xl:px-20">
        <div className="rounded-3xl border border-primary-100 bg-primary-50/60 p-7 md:p-11">
          <span className="mb-3 block text-xs font-semibold uppercase tracking-[0.2em] text-primary-600">Lokalnie na Podkarpaciu</span>
          <h2 className="font-heading text-2xl text-foreground-950 md:text-3xl">Ekspert kredytowy dla Sanoka, Bieszczad i okolic</h2>
          <p className="mt-4 max-w-3xl text-base leading-relaxed text-foreground-700">
            Spotkania prowadzę w Sanoku, a klientów z całego regionu obsługuję także telefonicznie i online. Dzięki temu możesz wygodnie omówić kredyt hipoteczny, gotówkowy, firmowy lub refinansowanie bez względu na miejscowość.
          </p>
          <ul className="mt-7 flex flex-wrap gap-2" aria-label="Obszar obsługi">
            {locations.map((location) => (
              <li key={location} className="rounded-full border border-primary-200 bg-white px-4 py-2 text-sm font-semibold text-primary-700">
                {location}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
